import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import React, { useEffect } from "react"
import { ParallaxProvider } from "react-scroll-parallax"

import { useGetConsolidatedObjectFields } from "@hooks/V2/storyblok"
import { trackSegmentEvent } from "@utils/analytics"
import { isConsolidatedProduct } from "@utils/shop"

const Page = ({ blok }: Storyblok.BlokProps<Storyblok.PageContent>) => {
  const getConsolidatedObjectFields = useGetConsolidatedObjectFields()

  const consolidatedTrackingProduct = blok.trackingProduct
    ? getConsolidatedObjectFields(
        blok.trackingProduct.uuid,
        blok.trackingProduct.content,
        1
      )
    : null

  const trackingEvent = blok.trackingEventObject?.[0]

  const consolidatedTrackingEventProduct =
    trackingEvent?.component === "productViewedEvent" && trackingEvent.product
      ? getConsolidatedObjectFields(
          trackingEvent.product.uuid,
          trackingEvent.product.content,
          1
        )
      : null

  useEffect(() => {
    if (trackingEvent) {
      //secondary check unneccessary after migration
      if (trackingEvent.component === "productViewedEvent") {
        if (consolidatedTrackingEventProduct) {
          trackSegmentEvent("Product Viewed", {
            product_id: isConsolidatedProduct(consolidatedTrackingEventProduct)
              ? consolidatedTrackingEventProduct.sku
              : consolidatedTrackingEventProduct.bundleCode,
            sku: isConsolidatedProduct(consolidatedTrackingEventProduct)
              ? consolidatedTrackingEventProduct.sku
              : consolidatedTrackingEventProduct.bundleCode,
            name: consolidatedTrackingEventProduct.name,
            content_type: isConsolidatedProduct(
              consolidatedTrackingEventProduct
            )
              ? "product"
              : "bundle",
            price: parseFloat(consolidatedTrackingEventProduct.price),
            value: parseFloat(consolidatedTrackingEventProduct.price),
            currency: `ZAR`, //TODO: we should update consolidatedItem to store this as we get it from the SDK
            url: window.location.pathname,
          })
        } else if (trackingEvent.customTrackingProductId) {
          trackSegmentEvent("Product Viewed", {
            product_id: trackingEvent.customTrackingProductId,
            price: 0.0,
            url: window.location.pathname,
          })
        }
      } else if (trackingEvent.component === "productListViewedEvent") {
        trackSegmentEvent("Product List Viewed", {
          list_id: trackingEvent.listId,
          category: trackingEvent.category,
          url: window.location.pathname,
        })
      }
    } else {
      // DEPRECATED in favour of new event partials
      // migrate to new eventPartial
      if (consolidatedTrackingProduct) {
        trackSegmentEvent("Product Viewed", {
          product_id: isConsolidatedProduct(consolidatedTrackingProduct)
            ? consolidatedTrackingProduct.sku
            : consolidatedTrackingProduct.bundleCode,
          sku: isConsolidatedProduct(consolidatedTrackingProduct)
            ? consolidatedTrackingProduct.sku
            : consolidatedTrackingProduct.bundleCode,
          name: consolidatedTrackingProduct.name,
          content_type: isConsolidatedProduct(consolidatedTrackingProduct)
            ? "product"
            : "bundle",
          price: parseFloat(consolidatedTrackingProduct.price),
          value: parseFloat(consolidatedTrackingProduct.price),
          currency: `ZAR`, //TODO: we should update consolidatedItem to store this as we gt it from the SDK
          url: window.location.pathname,
        })
      } else if (blok.customTrackingProductId) {
        trackSegmentEvent("Product Viewed", {
          product_id: blok.customTrackingProductId,
          price: 0.0,
          url: window.location.pathname,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const blokContentString = JSON.stringify(blok)

  const content =
    blok.body &&
    blok.body.map((childBlok) => (
      <StoryblokComponent blok={childBlok} key={childBlok._uid} />
    ))

  const title = blok.title?.length ? (
    <h1 className="text-5xl text-primary py-8 text-center font-bold tracking-wide">
      {blok.title}
    </h1>
  ) : null

  let pageContent: React.ReactNode = (
    <div
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    >
      {title}
      {content}
    </div>
  )

  if (blokContentString.includes('"component":"parallax_image"')) {
    pageContent = <ParallaxProvider>{pageContent}</ParallaxProvider>
  }

  return pageContent
}

export default Page
